import React from 'react';

import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

import { useExpandableContainer } from 'uiToolkitV1/ExpandableContainerProvider';

function PerfCalibrationBarChart({ data, isLoading }) {
  const { isExpanded = false } = useExpandableContainer();

  const getDomainValue = (value) => {
    if (value <= 5) return 5;
    if (value <= 10) return 10;
    if (value <= 20) return 20;
    if (value <= 50) return 50;
    if (value <= 100) return 100;
    if (value <= 250) return 250;
    if (value <= 500) return 500;
    if (value <= 1000) return 1000;
    if (value <= 2500) return 2500;
    if (value <= 5000) return 5000;
    return 10000;
  };

  return (
    <Skeleton isLoaded={!isLoading} height="255px">
      <Flex>
        <Box height={isExpanded ? '545px' : '255px'} width="100%">
          <ResponsiveContainer minHeight="255px" width="100%">
            <BarChart
              data={data}
              margin={{
                top: 20,
                right: 0,
                left: 0,
                bottom: 0,
              }}
              barSize={24}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="displayName"
                tickLine={false}
                tick={{ fill: '#666666', fontSize: 10, fontWeight: 'bold' }}
                label={{ value: 'Performance →', position: 'insideBottom', fill: '#666666' }}
                height={40}
              />
              <YAxis
                tickLine={false}
                tick={{ fill: '#666666', fontSize: 10, fontWeight: 'bold' }}
                label={{
                  value: 'No of People →',
                  angle: -90,
                  position: 'insideLeft',
                  fill: '#666666',
                  style: { textAnchor: 'middle' },
                }}
                tickFormatter={(value) => Math.round(value)}
                width={50}
                tickCount={6}
                domain={[0, (dataMax) => getDomainValue(dataMax)]}
              />
              <Bar dataKey="count" fill="#91CA7D" label={{ position: 'top', fill: '#666666', fontSize: 10 }} />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Flex>
    </Skeleton>
  );
}

export default PerfCalibrationBarChart;
